import React from 'react';
import {useFormik, FormikContext} from "formik";
import Switch from '@material-ui/core/Switch';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useDispatch, useSelector } from 'react-redux';
import {getDateFormManually, getDateForm} from '../../../../../@casino/lib/getDate';
import { setGetOperatorDetalization } from '../../store/thunk/setGetOperatorDetalization';

const useStyles = makeStyles(() => ({
    wrapFilter: {
        display: 'flex', marginRight: 12
    },
    wrapSwitch: {
        display: 'flex', alignItems: 'center', marginRight: 20
    },
    manuallyHelper: {
        color: '#fff', marginRight: 8
    },
    spo: {
        width: 40, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        background: '#141b33',
        borderRadius: '4px',
        color: '#fff',
        boxShadow: '4px 4px 8px 0px rgb(34 60 80 / 20%)',
    },
    inp: {
        border: 'none', 
        outline: 'none', 
        paddingLeft: 15, 
        borderRadius: 4, 
        background: '#34488c',
        color: '#fff'
    },
    wrapPanel: {
        width: '100%', display: 'flex', justifyContent: 'space-between', columnGap: 10
    },
    block: {
        height: 40, marginTop: 12, display: 'flex', alignItems: 'center', justifyContent: 'space-between', border: '1px solid #b0b0b0', borderRadius: 4, width: '25%', padding: 20
    },
    blockText: {
        color: '#fff', fontSize: 26, fontWeight: 700
    }
}));

const Cashier = ({groups}) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [active, setActive] = React.useState('cashier');
    
    React.useEffect(() => {
        dispatch(setGetOperatorDetalization({
            group: groups,
            date_from: 0,
            date_to: new Date().getTime(),
            air: false
        }))
    }, [groups])

    const initialValues = {
        check: false,
        date_from: NaN,
        date_to: NaN,
        air: false
    }

    const formik = useFormik({initialValues});
    const detalization = useSelector(state => state.groups.detalization);

    return (
        <div>
            <FormikContext.Provider value={formik} >
                <form>
                    <div style={{display: 'flex'}}>
                        <label htmlFor="check" className={classes.wrapSwitch}>
                            <span className={classes.manuallyHelper}>Ручн. время</span>
                            <Switch
                                checked={formik.values.check}
                                onChange={() => formik.setFieldValue('check', !formik.values.check)}
                                color="primary"
                                name="checkedB"
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                            />
                        </label>
                        <span className={classes.spo}>С</span>
                        <input 
                            type={formik.values.check ? 'datetime-local' : 'date' }
                            className={classes.inp}
                            value={formik.values.check ? getDateForm(+formik.values.date_from) : getDateFormManually(+formik.values.date_from)}
                            onChange={(v) => {
                                const date = new Date(v.target.value);
                                if (!formik.values.check) {
                                    date.setHours(0);
                                    date.setMinutes(0);
                                    date.setSeconds(0);
                                    date.setMilliseconds(0);
                                }
                                formik.setFieldValue('date_from', date.getTime());
                                dispatch(setGetOperatorDetalization({
                                    group: groups,
                                    air: formik.values.air,
                                    date_from: date.getTime(),
                                    date_to: !isNaN(formik.values.date_to) ? formik.values.date_to : new Date().getTime(),
                                }))
                            }}
                        />
                        <span className={classes.spo}>ПО</span>
                        <input 
                            type={formik.values.check ? 'datetime-local' : 'date' }
                            className={classes.inp}
                            value={formik.values.check ? getDateForm(+formik.values.date_to) : getDateFormManually(+formik.values.date_to)}
                            onChange={(v) => {
                                const date = new Date(v.target.value);
                                if (formik.values.check) {
                                    date.setHours(23);
                                    date.setMinutes(59);
                                    date.setSeconds(59);
                                    date.setMilliseconds(999);
                                }
                                formik.setFieldValue('date_to', date.getTime());
                                dispatch(setGetOperatorDetalization({
                                    group: groups,
                                    air: formik.values.air,
                                    date_from: !isNaN(formik.values.date_from) ? formik.values.date_from : 0,
                                    date_to: date.getTime(),
                                }))
                            }}
                        />
                    </div>
                    <div style={{display: 'flex', marginTop: 20, userSelect: 'none'}}>
                        <span
                        style={{color: active === 'cashier' ? '#FF005C' :'#fff', cursor: 'pointer', fontSize: 18, textTransform: 'uppercase', padding: '0 20px'}}
                        onClick={() => {
                            setActive('cashier');
                            formik.setFieldValue('air', false);
                            dispatch(setGetOperatorDetalization({
                                group: groups,
                                air: false,
                                date_from: !isNaN(formik.values.date_from) ? formik.values.date_from : 0,
                                date_to:  !isNaN(formik.values.date_to) ? formik.values.date_to : new Date().getTime(),
                            }))
                        }}>
                            Касса
                        </span>
                        <span  
                            style={{color: active === 'air' ? '#FF005C' :'#fff', cursor: 'pointer', fontSize: 18, textTransform: 'uppercase', padding: '0 20px'}} 
                            onClick={() => {
                                setActive('air')
                                formik.setFieldValue('air', true);
                                dispatch(setGetOperatorDetalization({
                                    group: groups,
                                    air: true,
                                    date_from: !isNaN(formik.values.date_from) ? formik.values.date_from : 0,
                                    date_to:  !isNaN(formik.values.date_to) ? formik.values.date_to : new Date().getTime(),
                                }))
                            }}
                            >Воздух</span>
                        <span  
                            style={{color: active === 'all' ? '#FF005C' :'#fff', cursor: 'pointer', fontSize: 18, textTransform: 'uppercase', padding: '0 20px'}} 
                            onClick={() => {
                                setActive('all')
                                formik.setFieldValue('air', 'all');
                                dispatch(setGetOperatorDetalization({
                                    group: groups,
                                    air: 'all',
                                    date_from: !isNaN(formik.values.date_from) ? formik.values.date_from : 0,
                                    date_to:  !isNaN(formik.values.date_to) ? formik.values.date_to : new Date().getTime(),
                                }))
                            }}
                            >Всего</span>
                    </div>
                    <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', columnGap: 10}}>
                        <div style={{height: 40, marginTop: 12, display: 'flex', alignItems: 'center', justifyContent: 'space-between', border: '1px solid #b0b0b0', borderRadius: 4, width: '25%', padding: 20}}>
                            <span style={{color: '#fff', fontSize: 26, fontWeight: 700,}}>Вход</span>
                            <span style={{color: '#fff', fontSize: 26, fontWeight: 700,}}>{detalization.sumDeposit ? detalization.sumDeposit.toFixed(2) : detalization.sumDeposit}₽</span>
                        </div>
                        <div style={{height: 40, marginTop: 12, display: 'flex', alignItems: 'center', justifyContent: 'space-between', border: '1px solid #b0b0b0', borderRadius: 4, width: '25%', padding: 20}}>
                            <span style={{color: '#fff', fontSize: 26, fontWeight: 700,}}>Выход</span>
                            <span style={{color: '#fff', fontSize: 26, fontWeight: 700,}}>{detalization.sumWithdrawal ? detalization.sumWithdrawal.toFixed(2) : detalization.sumWithdrawal} ₽</span>
                        </div>
            
                    
                        <div style={{height: 40, marginTop: 12, display: 'flex', alignItems: 'center', justifyContent: 'space-between', border: '1px solid #b0b0b0', borderRadius: 4, width: '25%', padding: 20}}>
                            <span style={{color: '#fff', fontSize: 26, fontWeight: 700,}}>Разница</span>
                            <span style={{color: '#fff', fontSize: 26, fontWeight: 700,}}>{detalization.sumDeposit && detalization.sumWithdrawal ? (detalization.sumDeposit - detalization.sumWithdrawal).toFixed(2) : detalization.sumDeposit - detalization.sumWithdrawal} ₽</span>
                        </div>
                        <div style={{height: 40, marginTop: 12, display: 'flex', alignItems: 'center', justifyContent: 'space-between', border: '1px solid #b0b0b0', borderRadius: 4, width: '25%', padding: 20}}>
                            <span style={{color: '#fff', fontSize: 26, fontWeight: 700,}}>Количество операций</span>
                            <span style={{color: '#fff', fontSize: 26, fontWeight: 700,}}>{detalization.count}</span>
                        </div>
                        
                    </div>
                </form>
            </FormikContext.Provider>
        </div>
        
    )
}

export default Cashier;